/**
 * The live websites per brand, for the brand details page.
 *
 * Generated and committed by `pnpm --filter @tapp/design-tokens generate:brand-sites`,
 * which inverts `getStyleNamespace` over the `brands` map in layer-base: one theme is
 * shared by several titles (the six red AD regionals all render as `adr`), and each title
 * has a main website and our shops app at `abonnement.<domain>`. It is generated rather
 * than read directly because layer-base extends this layer, so the dependency cannot run
 * the other way.
 *
 * See `stories.ts` for why playground-only helpers live in this directory.
 */

import brandSites from '@tapp/design-tokens/brand-sites.json';

export type BrandSite = {
  /** Every brand code on this domain — donaldduck.nl carries DON, DONEX and DONPO. */
  codes: string[];
  title: string;
  main: string;
  /** Null when the brand has no shop; equal to `main` when the main site *is* the shop. */
  subscription: string | null;
};

const sites: Record<string, BrandSite[]> = brandSites.sites;

/** Empty for a theme no brand with a domain is styled under — `dpg` and `tijdschrift`. */
export function sitesFor(brand: string) {
  return sites[brand] ?? [];
}

/** `https://abonnement.ad.nl` → `abonnement.ad.nl`, to label a link with its host. */
export function hostOf(url: string) {
  return url.replace(/^https?:\/\//, '');
}
